import * as calendarApi from 'app/api/calendar';
import { convertDateFromBackend, dateTimeFormat, dateTimeFormatDetailed } from 'app/l10n';

export * from './CalendarActions';

// TODO: move to Calendar.ts

export const CALENDAR_FETCH_EVENTS_REQUEST = 'CALENDAR_FETCH_EVENTS_REQUEST';
export const CALENDAR_FETCH_EVENTS_SUCCESS = 'CALENDAR_FETCH_EVENTS_SUCCESS';

// fetch events
export function fetchEventsRequest() {
  return { type: CALENDAR_FETCH_EVENTS_REQUEST };
}

export function fetchEventsSuccess(data) {
  return { type: CALENDAR_FETCH_EVENTS_SUCCESS, data };
}

// ----- Thunks

export function fetchEvents(month, userId, lookAhead) {
  return async function (dispatch, getState): Promise<void> {
    try {
      dispatch(fetchEventsRequest());

      const result = await calendarApi.fetchEvents(month, userId, lookAhead);
      if (result) {
        if (!result.errors && result.data && !result.data.errors) {
          const events = parseEvents(result.data.calendarEvents.events);
          dispatch(fetchEventsSuccess({ ...result.data.calendarEvents, events }));
          return true;
        } else {
          // Fetch error is dispatched by App.tsx to capture all GraphQL errors
          return false;
        }
      }
    } catch (err) {
      console.error(err);
    }
  };
}

const parseEvents = events =>
  events.map(event => ({
    ...event,
    instanceDate: convertDateFromBackend(event.date).format(dateTimeFormatDetailed),
    claimDetails: event.encodedClaimDetails ? JSON.parse(event.encodedClaimDetails) : null,
  }));
